import {Drawer} from "@mui/material";
import {DRAWER_WIDTH} from "appConstants";
import {WithChildren} from "types/ui";

interface Props extends WithChildren {}

export default function NavigationBarDesktop({children}: Props) {
  return (
    <Drawer
      PaperProps={{elevation: 10}}
      variant="permanent"
      sx={{
        display: "block",
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          zIndex: 1500,
          width: {laptop: "21.25%", desktop: DRAWER_WIDTH}, // DRAWER_WIDTH/laptop breakpoint = 304/1280 = 0.2375
        },
      }}
      open
    >
      {children}
    </Drawer>
  );
}
